import { render, staticRenderFns } from "./TraditionalResult.vue?vue&type=template&id=067dc575&scoped=true&"
import script from "./TraditionalResult.vue?vue&type=script&lang=js&"
export * from "./TraditionalResult.vue?vue&type=script&lang=js&"
import style0 from "./TraditionalResult.vue?vue&type=style&index=0&id=067dc575&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "067dc575",
  null
  
)

export default component.exports